export default __webpack_public_path__ + "static/media/img-0252-afghanistan-full-face.73e3446b.png";